import React, { useState, useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import styles from "./FollowUpSection.module.scss";
import remarkGfm from "remark-gfm";
import { DIGIT_ONE_EIGHTY } from "../../../constants/labelConstants";
import AILogoLight from "../../../assets/images/LightTheme/ai_logo_1.svg";
import AILogoDark from "../../../assets/images/DarkTheme/ai_logo_1.svg";
import { useAppSelector } from "../../../redux/hooks";
import { RootState } from "../../../redux/store";
interface Choice {
  key: string;
  desc: string;
  utterances?: string | null;
}
interface Response {
  question: string;
  response: string;
}
interface FollowUpSectionProps {
  affiliateCode: string;
  aboNumber: string;
  followUpChoices: Choice[];
  responseData: Response[]; // Updated prop
  setResponseData: React.Dispatch<React.SetStateAction<Response[]>>; // Updated prop
}

const FollowUpQuestion: React.FC<FollowUpSectionProps> = ({
  affiliateCode,
  aboNumber,
  followUpChoices,
  responseData,
  setResponseData,
}) => {
  const [errorMessage] = useState<string | null>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isFollowUpLoaded, setIsFollowUpLoaded] = useState<boolean>(false);
    const currentTheme = useAppSelector((state: RootState) => state.theme.currentTheme);
  

  useEffect(() => {
    if (isFollowUpLoaded) {
      return;
    }
    setIsFollowUpLoaded(true);
  }, [aboNumber, followUpChoices, isFollowUpLoaded]);
  useEffect(() => {
    if (contentRef.current) {
      const elementTop =
        contentRef.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementTop - DIGIT_ONE_EIGHTY,
        behavior: "smooth",
      });
    }
  }, [responseData]);

  return (
    <section className={styles.followup_section}>
      <div className={`followup_container ${styles.followup_container}`}>
        {responseData.map((item, index) => (
          <div
            key={index}
            className={`markdown_styled ${styles.markdown_styled} ${styles.response_block}`}
          >
            <div
              className={`question_text ${styles.question_text}`}
              ref={index === responseData.length - 1 ? contentRef : null}
            >
              {item.question}
            </div>
            <div className={styles.response_text}>
            <div className={styles.respone_logo}>
            <img
              src={currentTheme === "light" ? AILogoLight : AILogoDark}
              className={styles.ai_logo}
              alt="logo"
            />
            </div>
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                className={styles.tbl_wrapper}
              >
                {item.response}
              </ReactMarkdown>
            </div>
          </div>
        ))}
        {/* Error Message */}
        {errorMessage && (
          <div className={styles.error_container}>
            <p className={styles.error_message}>{errorMessage}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default FollowUpQuestion;
